import { UpaTarget } from './../../services/upa.service';
import { Component, Input, Output, ViewChild, ViewContainerRef, ViewEncapsulation, EventEmitter, Injector, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { TagTextData } from '../tag-text/tag-text.component';
import { ButtonOptions, Modal } from '../eva-button/eva-button.component';
import { AbstractComponent } from '../abstract.component';
import { GtmService } from '../../services/gtm.service';
import { ScrollService } from 'projects/common/services/scroll.service';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { DescriptionDetailedItem } from '../description-detailed/description-detailed-item.component';
import { SliderOptions } from '../slider/slider/slider.component';
import { ModalData } from '@shopping-angular-components/modal/lib/models/ModalData.model';
import { RoomTypeModalContentComponent } from '../modal/room-type-modal-content/room-type-modal-content.component';
import { ModuleService } from 'projects/common/services/module.service';

export enum EvaCardImageType {
  EMPTY = 'EMPTY',
  IMAGE = 'IMAGE',
  LEFT_ALIGNED_IMAGE = 'LEFT_ALIGNED_IMAGE',
  CENTERED_IMAGE = 'CENTERED_IMAGE',
  RIGHT_ALIGNED_IMAGE = 'RIGHT_ALIGNED_IMAGE',
  TINY_IMAGE = 'TINY_IMAGE',
  TINY_ICON = 'TINY_ICON',
  COMMON_ICON = 'COMMON_ICON',
  CENTERED_TINY_IMAGE = 'CENTERED_TINY_IMAGE',
  IMAGES_LIST = 'IMAGES_LIST',
  LEFT_IMAGE = 'LEFT_IMAGE'
}

export enum EvaCardImageVerticalOrientation {
  START = 'START',
  CENTER = 'CENTER',
  END = 'END'
}

export interface CardImage {
  image: string;
  images_list: string[];
  type: EvaCardImageType;
  alt: string;
  vertical_orientation?: EvaCardImageVerticalOrientation;
}

export interface EvaCardData {
  title?: TagTextData;
  subtitle?: TagTextData;
  text?: TagTextData;
  button_options: ButtonOptions;
  icon: string;
  background: string;
  index: number;
  card_image?: CardImage;
  scroll_target: string;
  items: DescriptionDetailedItem[];

  link: string; // deprecated
  link_title: string; // deprecated
  link_type: string; // deprecated
  image: string; // deprecated
  open_link_in_new_tab?: boolean;
  target?: string;
}

export interface EvaCardOptions {
  shadow?: boolean;
  line_shadow?: boolean;
  medium_line?: boolean;
  text_align?: string;
  show_index?: boolean;
  padding?: number;
}

@Component({
  selector: 'eva-card',
  template: `
    <span #evaCard class="eva-card eva-3-card" [ngClass]="{'-eva-3-shadow-2-hover': data.scroll_target || data.link, '-eva-3-shadow-line': options.line_shadow, 'LEFT_IMAGE': data.card_image?.type ===  'LEFT_IMAGE'}"
          [ngStyle]="{'background': data.background }">
      <optional-link class="use-flex-column" [link]="data.link" [scrollTarget]="data.scroll_target" [newTab]="!!data.open_link_in_new_tab" 
                                             [overrideClickHandler]="clickHandler" [noFollow]="nofollow" [target]="data.target">
        <div content class="use-flex-column eva-card-content" style="--card-padding: {{options.padding !== undefined ? options.padding + 'px' : '24px'}};">

        <!-- This Block is old-->
          <div class="image-wrapper -eva-3-center" *ngIf="data.image" [class.smaller]="!hasText() && !data.button_options">
            <img [src]="mediaService.getMediaUrl(data.image, this.imageSize)" loading="lazy" alt=""/>
          </div>
          <icons *ngIf="data.icon" [icon]="data.icon"></icons>
          <!-- End Block-->

          <div *ngIf="data.card_image && data.card_image.image && data.card_image.type !== 'EMPTY'" class="image-wrapper" 
                [ngClass]="[data.card_image.type, data.card_image.vertical_orientation ? data.card_image.vertical_orientation : 'START']">            
            <icons *ngIf="data.card_image.type === 'COMMON_ICON'" [icon]="data.card_image.image"></icons>
            <i *ngIf="data.card_image.type === 'TINY_ICON'" class="item-card-icon -eva-3-icon-md eva-3-icon-{{data.card_image.image}}"></i>
            <img *ngIf="data.card_image.type !== 'COMMON_ICON' && data.card_image.type !== 'TINY_ICON'"
              [src]="mediaService.getMediaUrl(data.card_image.image, this.imageSize)"
              [alt]="data.card_image.alt" loading="lazy">
          </div>

          <div *ngIf="data.card_image?.images_list" class="images-slider-wrapper">
            <!-- Se dibuja la primer imagen para la carga sin estática, sin js -->
            <img *ngIf="!sliderOptions"
              [src]="mediaService.getMediaUrl(data.card_image?.images_list?.[0], '300x200')"
              [ngStyle]="{width: '100%', height: '200px'}"
              [alt]="data.card_image?.alt" loading="lazy">

            <!-- TODO MIGRAR A SLIDER PRO -->
            <slider *ngIf="sliderOptions" [options]="sliderOptions" [moduleId]="this.getModuleId()" [uniqueId]="this.uniqueId" >
              <slider-item *ngFor="let image of data.card_image?.images_list" class="slider-item">
                <img [src]="mediaService.getMediaUrl(image, this.imageSize)"
                  [ngStyle]="{width: cardWidth + 'px', height: '200px'}"
                  [alt]="data.card_image?.alt" loading="lazy">
              </slider-item>
            </slider>
          </div>

          <div *ngIf="hasText() || data.button_options" class="content-wrapper"
                [ngClass]="{'no-border':!options.medium_line, 'with-image': data.image, 'separator': data.image || data.card_image?.image || data.icon || data.card_image?.images_list }"
                [style]="{ textAlign: options.text_align ? options.text_align : '', height: '100%'}">

            <p *ngIf="options.show_index && data.index" class="card-index -eva-3-tc-gray-4">{{data.index}}.</p>

            <tag-text *ngIf="data.title" class="card-title" [data]="data.title"></tag-text>

            <tag-text *ngIf="data.subtitle" class="card-subtitle" [data]="data.subtitle"></tag-text>

            <tag-text *ngIf="data.text" class="card-text" [ngClass]="options.text_align ? 'align-' + options.text_align : ''"
                      [data]="data.text"></tag-text>

            <div *ngIf="data.items && data.items.length > 0" class="card-items -eva-3-tc-gray-1">
              <span *ngFor="let item of data.items" class="item-card">
                <i *ngIf="item?.icon?.value" class="item-card-icon eva-3-icon-{{item.icon.value}}"></i>
                <em class="item-card-text">{{item.text.value}}</em>
              </span>
            </div>

            <eva-button *ngIf="data.button_options" class="-eva-3-mt-md" [options]="data.button_options" [moduleId]="getModuleId()"
                        [uniqueId]="uniqueId" [moduleIndex]="moduleIndex" [style]="{ textAlign: data.button_options.text_align || '' }"
                        [position]="positionIndex" [nofollow]="nofollow" [modalData]="modalData"></eva-button>

            <!-- deprecated tom-->
            <eva-button *ngIf="data.link && data.link_title && !data.button_options" class="-eva-3-mt-md"
                        [moduleId]="getModuleId()" [moduleIndex]="moduleIndex" [position]="positionIndex" [nofollow]="nofollow" [uniqueId]="uniqueId"
                        [options]="{ link: data.link, link_text: data.link_title, type: data.link_type, size: '-md' }"></eva-button>
          </div>
        </div>
      </optional-link>
    </span>

  `,
  styleUrls: ['./eva-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EvaCardComponent extends AbstractComponent implements OnInit, OnChanges {
  private static MODULE_ID = 'EvaCardsWrapperModule';

  @ViewChild('evaCard', { read: ViewContainerRef, static: true }) evaCard: ViewContainerRef;

  @Input() uniqueId?: string;
  @Input() options: EvaCardOptions;
  @Input() data: EvaCardData;
  @Input() positionIndex: number;
  @Input() nofollow: boolean;
  @Input() cardWidth: number;
  @Input() itemsToShow: number;
  @Input() viewType: 'grid' | 'slide';
  @Input() moduleIndex: number;

  @Output() clickEvent: EventEmitter<any> = new EventEmitter<any>();

  sliderOptions: SliderOptions;
  modalData: ModalData;

  initialized: boolean = false;

  imageSize: string = '';
  mobileGridSizeList = {
    1: "570x300",
    2: "340x400",
    default: "340x400"
  };
  mobileSlideSizeList = {
    1: "417x300",
    default: "417x300"
  };
  desktopSizeList = {
    1: "1280x200",
    2: "632x200",
    3: "410x200",
    4: "300x200",
    5: "353x300",
    6: "305x280",
    default: "300x200"
  };

  constructor(
    injector: Injector,
    private moduleService: ModuleService,
    private gtmService: GtmService,
    public mediaService: MediaPictureService,
  ) {
    super(injector);
  }

  ngOnInit() {
    if (this.data.button_options?.modal) {
      const landingModel = this.landingModelService.getLandingModel();

      const modal: Modal = this.data.button_options.modal;
      this.modalData = {
        id: EvaCardComponent.MODULE_ID + '-modal',
        title: this.data.button_options.modal.modal_title,
        contentComponent: RoomTypeModalContentComponent,
        contentModel: {
          title: modal.title,
          subTitle: modal.sub_title,
          text: modal.text,
          amenities: modal.category,
          images: this.data.card_image?.images_list,
          device: landingModel.device
        },
        product: "nymeria-gui",
        flow: landingModel.flow,
        isWebview: landingModel.webview,
        evaClasses: '-no-padding'
      }
    }

    this.resolveImageSize();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.data.card_image?.images_list && changes.cardWidth?.currentValue != changes.cardWidth?.previousValue) {
      this.initializeSlider(this.cardWidth, this.data.card_image.images_list.length);
    }
  }

  initializeSlider(maxWidth: number, items_length: number) {
    this.sliderOptions = {
      id: 'card-images-carrousel',
      show_arrows: true,
      show_dots: false,
      items_to_show: 1,
      items_length: items_length,
      max_fixed_width: maxWidth,
      mobile_card_size: 100,
      items_to_move: 1,
      space_between: 0,
      arrows_size: '-sm',
      show_loader: true,
      deactivate_touch: true,
      arrows_inner_container: true
    }
  }

  resolveImageSize() {
    if (this.moduleService.isRestrictResources(EvaCardComponent.MODULE_ID)) {
      const sizeList = this.screenType != 'MOBILE' ? this.desktopSizeList : (this.viewType == 'grid' ? this.mobileGridSizeList : this.mobileSlideSizeList);
      this.imageSize = sizeList[this.itemsToShow] || sizeList['default'];
    }
  }

  getModuleId(): string {
    return EvaCardComponent.MODULE_ID;
  }

  clickHandler = (event: MouseEvent) => {
    if (this.data.link || this.data.scroll_target) {
      const label = this.data.title ? this.data.title.text : this.data.text ? this.data.text.text : 'no-label';
      this.upaService.trackClickTopic({
        label,
        uniqueId: this.uniqueId,
        moduleId: this.getModuleId(),
        moduleIndex: this.moduleIndex,
        positionIndex: this.positionIndex,
        target: UpaTarget.CARD,
        href: this.data.link || this.data.scroll_target
      }, event);

      this.trackGtm(this.data.link || this.data.scroll_target, this.positionIndex);

      if (this.data.scroll_target != null && this.data.scroll_target != '') {
        ScrollService.scrollTo(this.data.scroll_target);
      }

      this.clickEvent.emit();
    }
  };

  hasText(): boolean {
    return !!((this.options.show_index && this.data.index) || this.data.title || this.data.text);
  }

  hasLink(): boolean {
    return !!(this.data.link && !this.data.link_title);
  }

  trackGtm(link, i) {
    this.gtmService.trackEventIfApplicable('user-action', 'tabbox-' + i, 'Click', link ? link : null);
  }
}
